import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-field-error',
  templateUrl: './field-error.component.html',
  styleUrls: ['./field-error.component.scss'],
})
export class FieldErrorComponent {
  @Input() control: AbstractControl | null = new FormControl();
  @Input() fieldName = '';
  @Input() errorName = '';
  @Input() errorMsg = '';
  @Input() isShowError = false;
  @Input() className = '';
  @Input() errorDesc = '';
  @Input() translateErrorMsg = '';
}
